export default __webpack_public_path__ + "static/media/Power4Future_ITA_28_05_2021.57ffb475.pdf";